export const usersConstants = {
  REQUEST: 'USERS_REQUEST',
  UPDATE: 'USERS_UPDATE',
  SUCCESS: 'USERS_SUCCESS',
  FAILURE: 'USERS_FAILURE',
  CLEAR: 'USERS_CLEAR',
  REMOVE: 'USERS_REMOVE',
}
